(function () {
  function init() {
    var jsonEl = document.querySelector('script[id^="ProductJson-"]');
    if (!jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var variants = product.variants;
    var sectionId = (document.querySelector('select[name="id"]') || {}).id;
    if (!sectionId) return;
    sectionId = sectionId.replace('ProductSelect-', '');

    var priceEl   = document.getElementById('ProductPrice-' + sectionId);
    var compareEl = document.getElementById('ComparePrice-' + sectionId);
    if (!priceEl) return;

    function updatePrice() {
      var variantId = parseInt(document.getElementById('ProductSelect-' + sectionId).value, 10);
      var variant = variants.find(function (v) { return v.id === variantId; });
      if (!variant) return;

      priceEl.innerHTML = window.theme.Currency.formatMoney(variant.price, window.theme.moneyFormat);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = window.theme.Currency.formatMoney(variant.compare_at_price, window.theme.moneyFormat);
          compareEl.classList.remove('hide');
        } else {
          compareEl.classList.add('hide');
        }
      }
    }

    // Listen for swatch radio changes
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('swatchInput')) {
        setTimeout(updatePrice, 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();